/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetAvailableDocumentsRequest = {
  properties: {
    professionId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
